import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, tap, throwError } from 'rxjs';
import { RecruiterOnboardingApi } from '@tribuu-api';
import { VacancyActions } from './vacancy.actions';

export interface VacancyStateModel {
  lastPublishedSlug: string | null;
  loading: boolean;
}

const defaults: VacancyStateModel = {
  lastPublishedSlug: null,
  loading: false,
};

@State<VacancyStateModel>({
  name: 'vacancy',
  defaults,
})
@Injectable()
export class VacancyState {
  private readonly onboardingApi = inject(RecruiterOnboardingApi);

  @Selector()
  static lastPublishedSlug(state: VacancyStateModel): string | null {
    return state.lastPublishedSlug;
  }

  @Selector()
  static isLoading(state: VacancyStateModel): boolean {
    return state.loading;
  }

  @Action(VacancyActions.Publish)
  publish(ctx: StateContext<VacancyStateModel>, { dto }: VacancyActions.Publish) {
    ctx.patchState({ loading: true });
    return this.onboardingApi.recruiterCreateVacancy({ recruiterCreateVacancyDto: dto }).pipe(
      tap((res) => {
        ctx.patchState({
          lastPublishedSlug: res.slug,
          loading: false,
        });
      }),
      catchError((err) => {
        ctx.patchState({ loading: false });
        return throwError(() => err);
      })
    );
  }

  @Action(VacancyActions.Reset)
  reset(ctx: StateContext<VacancyStateModel>): void {
    ctx.setState(defaults);
  }
}
